import Quiz from './components/Quiz/Quiz';
import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
import { useMemo } from 'react';
import defaultBackground from './assets/images/bg.png';
import { CSSTransition } from 'react-transition-group';
import Winner from './components/Winner/Winner';

function App() {
  const { voteState, currentState, isVisible } = useVote();

  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    questionFontSize,
    answerFontSize,
    varNumFontSize,
    winnerFontSize,
    marginTopQuiz,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <div className="advt-wrapper">
        <CSSTransition
          in={isVisible && ['S2', 'S3', 'S4'].includes(currentState)}
          timeout={500}
          classNames="fade-scale"
          unmountOnExit>
          <AdvtFullSize advtInfo={advt_info} />
        </CSSTransition>
      </div>

      <CSSTransition
        in={
          isVisible &&
          voteState &&
          ['S1', 'S2', 'S3', 'S4'].includes(currentState)
        }
        timeout={500}
        classNames="fade-scale"
        unmountOnExit>
        <Quiz
          variants={voteState?.vars}
          title={voteState?.title}
          questionImgUrl={voteState?.questionImgUrl}
          currentState={currentState}
          questionFontSize={questionFontSize}
          answerFontSize={answerFontSize}
          varNumFontSize={varNumFontSize}
          winnerFontSize={winnerFontSize}
          marginTopQuiz={marginTopQuiz}
        />
      </CSSTransition>

      {currentState === 'S4' && (
        <Winner
          questionImgUrl={voteState?.questionImgUrl}
          winnerFontSize={winnerFontSize}
        />
      )}

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
